import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import contactHero from '../assets/images/home.jpg';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: 'Room Booking Inquiry',
        message: ''
    });
    
    const [status, setStatus] = useState({ type: '', message: '' });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ type: '', message: '' });

        try {
            const response = await fetch('http://localhost/maisonmosh/backend/api/contact.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();
            
            if (data.success) {
                setStatus({ type: 'success', message: 'Message sent successfully! We will get back to you soon.' });
                setFormData({
                    name: '',
                    email: '',
                    subject: 'Room Booking Inquiry',
                    message: ''
                });
            } else {
                setStatus({ type: 'error', message: data.message || 'Something went wrong. Please try again.' });
            }
        } catch (error) {
            setStatus({ type: 'error', message: 'Network error. Please try again.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', color: '#333' }}>
            <Header />
            
            {/* Hero Section */}
            <section style={{
                height: '50vh',
                minHeight: '400px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'white',
                background: `linear-gradient(rgba(44,62,80,0.7), rgba(44,62,80,0.7)), url(${contactHero})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}>
                <div style={{ maxWidth: '800px', padding: '0 20px' }}>
                    <h1 style={{ fontSize: '56px', fontWeight: '300', marginBottom: '20px' }}>Contact Us</h1>
                    <p style={{ fontSize: '20px', fontWeight: '300', opacity: '0.9' }}>Get in touch with Maison Mosh II</p>
                </div>
            </section>

            {/* Main Contact Section */}
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '80px 20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px' }}>
                    
                    {/* Left Column - Info */}
                    <div>
                        <h2 style={{ fontSize: '36px', fontWeight: '300', marginBottom: '10px', color: '#2c3e50' }}>Get In Touch</h2>
                        <p style={{ fontSize: '18px', color: '#666', marginBottom: '40px' }}>We would love to hear from you</p>
                        
                        {/* Address */}
                        <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
                            <div style={{ width: '50px', height: '50px', background: '#f5f0eb', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>📍</div>
                            <div>
                                <h3 style={{ fontSize: '18px', fontWeight: '500', color: '#2c3e50', marginBottom: '5px' }}>Address</h3>
                                <p style={{ fontSize: '16px', color: '#666', margin: 0 }}>31 Mopeli Street, Moshoeshoe II</p>
                                <p style={{ fontSize: '16px', color: '#666', margin: 0 }}>Maseru 100, Lesotho</p>
                            </div>
                        </div>
                        
                        {/* Phone */}
                        <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
                            <div style={{ width: '50px', height: '50px', background: '#f5f0eb', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>📞</div>
                            <div>
                                <h3 style={{ fontSize: '18px', fontWeight: '500', color: '#2c3e50', marginBottom: '5px' }}>Phone</h3>
                                <p style={{ fontSize: '16px', color: '#666', margin: 0 }}>
                                    <a href="tel:+26656333882" style={{ color: '#2c3e50', textDecoration: 'none' }}>+266 56 333 882</a>
                                </p>
                                <p style={{ fontSize: '16px', color: '#666', margin: 0 }}>
                                    <a href="tel:+26662144500" style={{ color: '#2c3e50', textDecoration: 'none' }}>+266 62 144 500</a>
                                </p>
                                <span style={{ fontSize: '13px', color: '#a58e7c' }}>Call or WhatsApp</span>
                            </div>
                        </div>
                        
                        {/* Email - UPDATED to .co.ls */}
                        <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
                            <div style={{ width: '50px', height: '50px', background: '#f5f0eb', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>✉️</div>
                            <div>
                                <h3 style={{ fontSize: '18px', fontWeight: '500', color: '#2c3e50', marginBottom: '5px' }}>Email</h3>
                                <p style={{ fontSize: '16px', color: '#666', margin: 0 }}>
                                    <a href="mailto:info@maisonmosh.co.ls" style={{ color: '#2c3e50', textDecoration: 'none' }}>
                                        info@maisonmosh.co.ls
                                    </a>
                                </p>
                            </div>
                        </div>
                        
                        {/* Check-in */}
                        <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
                            <div style={{ width: '50px', height: '50px', background: '#f5f0eb', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>🕒</div>
                            <div>
                                <h3 style={{ fontSize: '18px', fontWeight: '500', color: '#2c3e50', marginBottom: '5px' }}>Check-in / Check-out</h3>
                                <p style={{ fontSize: '16px', color: '#666', margin: 0 }}>Check-in: 2:00 PM</p>
                                <p style={{ fontSize: '16px', color: '#666', margin: 0 }}>Check-out: 10:00 AM</p>
                            </div>
                        </div>
                        
                        {/* Social Media */}
                        <div style={{ marginTop: '30px', paddingTop: '30px', borderTop: '1px solid #eee' }}>
                            <h3 style={{ fontSize: '18px', fontWeight: '500', marginBottom: '15px', color: '#2c3e50' }}>Follow Us</h3>
                            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                                <a href="#" style={{ padding: '10px 20px', background: '#f5f0eb', borderRadius: '5px', textDecoration: 'none', fontSize: '14px', color: '#2c3e50', display: 'inline-flex', alignItems: 'center', gap: '8px', transition: 'all 0.3s ease' }} onMouseEnter={(e) => { e.target.style.background = '#1877f2'; e.target.style.color = 'white'; }} onMouseLeave={(e) => { e.target.style.background = '#f5f0eb'; e.target.style.color = '#2c3e50'; }}>
                                    <i className="fab fa-facebook-f"></i> Facebook
                                </a>
                                <a href="#" style={{ padding: '10px 20px', background: '#f5f0eb', borderRadius: '5px', textDecoration: 'none', fontSize: '14px', color: '#2c3e50', display: 'inline-flex', alignItems: 'center', gap: '8px', transition: 'all 0.3s ease' }} onMouseEnter={(e) => { e.target.style.background = '#e4405f'; e.target.style.color = 'white'; }} onMouseLeave={(e) => { e.target.style.background = '#f5f0eb'; e.target.style.color = '#2c3e50'; }}>
                                    <i className="fab fa-instagram"></i> Instagram
                                </a>
                                <a href="#" style={{ padding: '10px 20px', background: '#f5f0eb', borderRadius: '5px', textDecoration: 'none', fontSize: '14px', color: '#2c3e50', display: 'inline-flex', alignItems: 'center', gap: '8px', transition: 'all 0.3s ease' }} onMouseEnter={(e) => { e.target.style.background = '#000000'; e.target.style.color = 'white'; }} onMouseLeave={(e) => { e.target.style.background = '#f5f0eb'; e.target.style.color = '#2c3e50'; }}>
                                    <i className="fab fa-tiktok"></i> TikTok
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    {/* Right Column - Form */}
                    <div style={{ background: '#f5f0eb', padding: '40px', borderRadius: '8px' }}>
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                                <div>
                                    <label style={{ display: 'block', fontWeight: '500', fontSize: '13px', color: '#2c3e50', marginBottom: '8px' }}>Your Name *</label>
                                    <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Enter your name" style={{ width: '100%', padding: '12px 15px', border: '1px solid #ddd', borderRadius: '5px', fontSize: '15px', background: 'white' }} />
                                </div>
                                <div>
                                    <label style={{ display: 'block', fontWeight: '500', fontSize: '13px', color: '#2c3e50', marginBottom: '8px' }}>Email Address *</label>
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Enter your email" style={{ width: '100%', padding: '12px 15px', border: '1px solid #ddd', borderRadius: '5px', fontSize: '15px', background: 'white' }} />
                                </div>
                            </div>
                            
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', fontWeight: '500', fontSize: '13px', color: '#2c3e50', marginBottom: '8px' }}>Subject</label>
                                <select name="subject" value={formData.subject} onChange={handleChange} style={{ width: '100%', padding: '12px 15px', border: '1px solid #ddd', borderRadius: '5px', fontSize: '15px', background: 'white' }}>
                                    <option>Room Booking Inquiry</option>
                                    <option>General Inquiry</option>
                                    <option>Corporate Booking</option>
                                    <option>Event Inquiry</option>
                                    <option>Other</option>
                                </select>
                            </div>
                            
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', fontWeight: '500', fontSize: '13px', color: '#2c3e50', marginBottom: '8px' }}>Message *</label>
                                <textarea name="message" value={formData.message} onChange={handleChange} rows="5" required placeholder="Tell us about your stay or questions..." style={{ width: '100%', padding: '12px 15px', border: '1px solid #ddd', borderRadius: '5px', fontSize: '15px', background: 'white', fontFamily: 'inherit' }}></textarea>
                            </div>
                            
                            {status.message && (
                                <div style={{ padding: '12px 16px', borderRadius: '5px', marginBottom: '20px', fontSize: '14px', textAlign: 'center', background: status.type === 'success' ? '#d4edda' : '#f8d7da', color: status.type === 'success' ? '#155724' : '#721c24', border: status.type === 'success' ? '1px solid #c3e6cb' : '1px solid #f5c6cb' }}>
                                    {status.message}
                                </div>
                            )}
                            
                            <button type="submit" disabled={loading} style={{ width: '100%', padding: '14px', fontSize: '16px', background: '#a58e7c', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: '600', transition: 'all 0.3s ease' }} onMouseEnter={(e) => e.target.style.background = '#7a6655'} onMouseLeave={(e) => e.target.style.background = '#a58e7c'}>
                                {loading ? 'Sending...' : 'Send Message'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            {/* Map Section */}
            <section style={{ padding: '60px 0', background: '#f5f0eb', textAlign: 'center' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <h2 style={{ fontSize: '36px', fontWeight: '300', marginBottom: '10px', color: '#2c3e50' }}>Find Us</h2>
                    <p style={{ fontSize: '18px', color: '#666', marginBottom: '30px' }}>31 Mopeli Street, Moshoeshoe II, Maseru 100, Lesotho</p>
                    <div style={{ height: '400px', width: '100%', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
                        <iframe 
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2650.3158713872176!2d27.498663399999998!3d-29.300261700000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e8dcbb26e9b7ef3%3A0xa1c32937de7d4d92!2sMAISON%20MOSH%20II%20GUEST%20HOUSE!5e1!3m2!1sen!2sls!4v1785321977167!5m2!1sen!2sls" 
                            width="100%" 
                            height="100%" 
                            style={{ border: 0 }} 
                            allowFullScreen="" 
                            loading="lazy"
                            referrerPolicy="strict-origin-when-cross-origin"
                            title="Maison Mosh II Location"
                        ></iframe>
                    </div>
                    <p style={{ marginTop: '15px', fontSize: '14px', color: '#666' }}>31 Mopeli Street, Moshoeshoe II, Maseru 100, Lesotho</p>
                </div>
            </section>

            {/* CTA Section */}
            <section style={{ padding: '60px 0', background: '#2c3e50', color: 'white', textAlign: 'center' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <h2 style={{ fontSize: '32px', fontWeight: '300', marginBottom: '10px', color: 'white' }}>Book Directly</h2>
                    <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.8)', marginBottom: '30px' }}>Call or WhatsApp us for immediate assistance</p>
                    <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <a href="tel:+26656333882" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 30px', background: '#a58e7c', color: 'white', textDecoration: 'none', borderRadius: '4px', fontWeight: '600', fontSize: '14px', border: '2px solid #a58e7c', transition: 'all 0.3s ease' }} onMouseEnter={(e) => { e.target.style.background = '#7a6655'; e.target.style.borderColor = '#7a6655'; }} onMouseLeave={(e) => { e.target.style.background = '#a58e7c'; e.target.style.borderColor = '#a58e7c'; }}>
                            <i className="fas fa-phone"></i> Call Us
                        </a>
                        <a href="https://wa.me/26656333882" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 30px', background: 'transparent', color: 'white', textDecoration: 'none', borderRadius: '4px', fontWeight: '600', fontSize: '14px', border: '2px solid white', transition: 'all 0.3s ease' }} onMouseEnter={(e) => { e.target.style.background = 'white'; e.target.style.color = '#2c3e50'; }} onMouseLeave={(e) => { e.target.style.background = 'transparent'; e.target.style.color = 'white'; }}>
                            <i className="fab fa-whatsapp"></i> WhatsApp
                        </a>
                    </div>
                    <div style={{ marginTop: '15px', fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
                        <a href="tel:+26656333882" style={{ color: 'white', textDecoration: 'none', fontWeight: '500' }}>+266 56 333 882</a>
                        <span style={{ margin: '0 12px', color: 'rgba(255,255,255,0.3)' }}>|</span>
                        <a href="tel:+26662144500" style={{ color: 'white', textDecoration: 'none', fontWeight: '500' }}>+266 62 144 500</a>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Contact;